export default function TransitionBlock3() {
	return (
		<div className="relative">
			<svg
				className="absolute top-0 left-0 w-full"
				viewBox="0 0 1440 100"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill="#fff" // <-- color de fondo del siguiente bloque
					d="M0,64L48,58.7C96,53,192,43,288,53.3C384,64,480,96,576,96C672,96,768,64,864,58.7C960,53,1056,75,1152,85.3C1248,96,1344,96,1392,96L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
				></path>
			</svg>
		</div>
	);
}
